import { lazy } from 'react'

import Dettagli from './dettagli'

export default {
    path: '/incassi',
    title: 'Incassi',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:incassoId',
            title: 'Incasso: {{params.incassoId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Dettagli]
        }
    ]
}